<template>
  <div :class="setBorder">
    <div @click="click" :class="itemStyles" class="text-center">
      <div class="thumb" v-bind:style="{ backgroundImage: 'url(static/images/' + thumbnail + ')' }"></div>
      <div></div>
      <br>
      <p>{{title}}</p>
      <br>
    </div>
    <div>
      <button class="no-print btn btn-delete" v-if="isRemovable()" @click="removeElement">entfernen</button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "menuItem",
    props: {
      visible: Boolean,
      title: String,
      imgURL: String,
      code: String,
      thumbnail: String,
      ite: Object,
      height: String,
      selected: {
        type: Object,
        default: () => {
          return {code: null}
        }
      }
    },
    computed: {
      itemStyles() {
        return {
          'marked': this.selected.code === this.code
        }
      },
      setBorder() {
        return {
          'bordright': this.ite.title === "Laufsohle"
        }
      },
    },
    methods: {
      click: function (e) {
        console.log(this.selected);
        this.$emit('click');
      },
      removeElement: function (e) {
        this.ite.visible = false;
        this.$emit('removeElement')
      },
      isRemovable: function () {
        if (this.ite.removable) {
          if (this.ite.visible) {
            return true;
          }
        }
        return false;
      },

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/menuItem.vue